<script lang="js">
	import { mapState, mapGetters } from 'vuex';
	import { query } from "sinao-corejs";
	import i18n from '@/i18n';
	import { dispatchEvent } from "@/mixins/methods";

	import MenuSection from './MenuSection';
	import MenuColor from './MenuColor';
	import MenuCurrency from './MenuCurrency';
	import MenuModels from './MenuModels';
	import MenuTags from './MenuTags';
	import MenuEstimate from './MenuEstimate';
	import MenuLang from './MenuLang';
	import MenuSap from './MenuSap.vue';

	export default {
		name: 'Menu',
		components: {
			MenuSection,
			MenuColor,
			MenuCurrency,
			MenuModels,
			MenuTags,
			MenuEstimate,
			MenuLang,
			MenuSap
		},
		props: [],
		data () {
			return {
				displayCatalogueOnNewLine: false,
				loadedModelId: null,
				downpaymentTable: false,
				modelName: '',
				openMenu: false,
				is_pro: false,
			};
		},
		computed: {
			...mapState({
				appId: state => state.app.id,
				app: state => state.app,
				page: state => state.page,
				home: state => state.home,
				vat: state => state.vat,
				downpayment: state => state.downpayment,
				billing: state => state.billing,
				settings: state => state.settings,
				background: state => state.settings.accentColor.background,
				foreground: state => state.settings.accentColor.foreground,
				rights: state => state.app.rights,
				isEditable: state => state.home.isEditable,
        		contactInfos: state => state.contacts.contactInfos,
				isRecurring: state => state.recurring.isRecurringInvoice
			}),
			...mapGetters([
				'getTableIds',
				'enabledHeaders',
				'enabledHeadersValues',
				'hasAccessToCurrencies',
				'isRecurringReady',
				'isAmountValid',
				'isWhiteLabel',
				'canLinkSinaoHelpCenter',
				'displayMenuSap'
			]),
			
		},
			watch: {
				isAmountValid(object) {
					if (object.value === false) {
						this.$bvToast.toast(i18n.t(object.message), {
							title: i18n.t("Montant erroné"),
							variant: "danger",
							solid: true
						});
					}
				}
		},
		async created() {
			await query({
				operationId: "app.subscription.get",
				params: {
					appId: this.appId
				}
			}).then(response => {
				const proPlans = ['pro', 'business-free', 'business-monthly', 'business-yearly'];
				this.is_pro = proPlans.includes(response.plan.nickname);
			});
		},
		methods: {
			saveDocument() {
				if (this.isAmountValid.value === false) {
					this.$bvToast.toast(i18n.t(this.isAmountValid.message), {
						title: i18n.t("Montant erroné"),
						variant: "danger",
						solid: true
					});
					return;
				}
				if (!this.isRecurringReady) {
					this.$bvToast.toast(i18n.t("Plan de facturation terminé"), {
						title: i18n.t("Plan de facturation"),
						variant: "danger",
						solid: true
					});
					return;
				}

				if (this.appId === 0) {
					this.home.showRegisterModal = true;
				} else {
					this.$store.dispatch("saveDocument");
				}
			},
			closeDocument() {
				let page = 'invoices';
				if (this.isRecurring)
					page = 'autoinvoicing';
				else if (this.page.type == 'invoices')
					page = 'billing';
				else if (this.page.type == 'quotes')
					page = 'quote';

				dispatchEvent({
					modalName: null,
					source: "billing",
					action: "return_to",
					data: { page: page }
				});	

				// const { url } = this.app.app;
				// if (this.page.type === 'invoices') {
				// 	window.parent.location.href = `${url}accounting/billing/main/`;
				// } else {
				// 	window.parent.location.href = `${url}accounting/quote/main/`;
				// }
			},
      openModalDocumentStyle() {
        this.$store.commit("showModalDocumentStyle", true);
        this.$store.commit("showModalDocumentStyleCloseButton", true);
      }
		}
	};
</script>

<template lang="html">
	<div class="floating-menu__wrapper">
		<b-button
			class="floating-menu__control floating-menu__control--open"
			block
			variant="light"
			:class="{ 'floating-menu__control--hidden': openMenu }"
			:disabled="openMenu"
			:style="{ 'background-color': background, color: foreground }"
			@click="openMenu = true"
		>
			<b-icon icon="gear" />
		</b-button>

		<div class="floating-menu" :class="{ 'floating-menu--open': openMenu }">
			<b-button
				class="floating-menu__control floating-menu__control--close"
				block
				variant="light"
				@click="openMenu = false"
				style="border-radius: 0 !important;"
			>
				{{ $t("Fermer le menu") }}
			</b-button>

			<div v-if="isEditable">

				<div class="floating-menu__section">
					<b-button
						block
						squared
						variant="light"
						class="floating-menu-tab__control btn-light btn-block rounded-0 text-left"
						style="font-size: 0.93rem"
						@click="openModalDocumentStyle()"
					>
						<b-row>
						<b-col cols="10">
							<b-icon icon="palette" />
							{{ $t('Design') }}
						</b-col>
						<b-col cols="2"></b-col>
						</b-row>
					</b-button>
				</div>

				<div class="floating-menu__section">
					<MenuSection
						:title="$t('Modèles')"
						icon="clipboard"
					>
						<span v-if="canLinkSinaoHelpCenter">
							<!-- <i>
								<span style="opacity: 0.6">
								<b-icon-question-circle-fill font-scale="1.4" /> {{ $t("Pour créer un modèle, consulter") }}
								</span>
								<a href="https://help.sinao.fr/fr/articles/2614712-comment-utiliser-les-modeles-pour-des-devis-factures-similaires" target="_BLANK"> {{ $t("comment utiliser les modèles") }} </a>
								<span style="opacity: 0.6">.</span>
							</i> -->

							<div class="menu-sap__hint">
								<b-icon-question-circle-fill font-scale="1.4" class="menu-sap__hint-icon" />
								<span>
									{{ $t('Pour créer un modèle, consulter') }}
									<a href="https://help.sinao.fr/fr/articles/2614712-comment-utiliser-les-modeles-pour-des-devis-factures-similaires" target="_BLANK"> {{ $t("comment utiliser les modèles") }} </a>
									.
								</span>
							</div>
						</span>
						<ul class="floating-menu__list">
							<li class="floating-menu__list-item">
								<MenuModels />
							</li>
						</ul>
					</MenuSection>
				</div>

				<div class="floating-menu__section" v-if="displayMenuSap">
					<MenuSection title="SAP" icon="person">
						<MenuSap />
					</MenuSection>
				</div>

				<div class="floating-menu__section">
					<MenuSection :title="$t('Tags')" icon="hash">
						<MenuTags />
					</MenuSection>
				</div>

				
				<MenuSection
					:title="$t('Devises')"
					icon="cash"
				>
					<MenuCurrency />
				</MenuSection>
				
				<MenuSection
					:title="$t('Langues')"
					icon="printer"
				>
					<MenuLang />
				</MenuSection>
				

				<div class="floating-menu__section" v-if="is_pro" style="position: relative;">
					<!-- <div class="tagBeta">
						Beta
					</div> -->
					<MenuSection 
						:title="$t('Aide au chiffrage')"
						additionalTagIA="true"
					>
						<MenuEstimate />
					</MenuSection>
				</div>
			</div>

			<div class="floating-menu__section">
				<b-card class="floating-menu__item">
					<b-overlay
						:show="home.savingDocument"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="dark"
					>
						<s-button
							type="success"
							:disabled="home.savingDocument"
							@click="saveDocument"
						>
							{{ page.type === "invoices" ? $t("Enregistrer la facture") : $t("Enregistrer le devis") }}
						</s-button>
					</b-overlay>

					<div class="mt-2" />

					<s-button
						type="border"
						:disabled="home.savingDocument"
						@click="closeDocument"
					>
						{{ $t("Annuler") }}
					</s-button>
				</b-card>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
	@import "sinao-corevue/public/assets/_variables.scss";
	@import "sinao-corevue/public/assets/_buttons.scss";

	.floating-menu {
		width: 250px;
		position: fixed;
		top: 48px;
		right: 0;
		width: 255px;
		margin: 0 10px;
		overflow-y: auto;
		overflow-x: hidden;
		border-radius: 5px;
		max-height: calc(100vh - 30px);
		overscroll-behavior: contain;
		border: 1px solid rgba(0,0,0,.125);

		scrollbar-color: transparent transparent;
		scrollbar-width: thin;
		transition: scrollbar-color 300ms ease-in-out;

		&:hover {
			scrollbar-color: #aeaeae transparent;
		}

		&__wrapper {
			position: absolute;
			top: 0;
			right: 0;
			height: 100%;
			z-index: 100;
		}

		&__list {
			list-style: none;
			padding: 0;
		}
		&__list-item {
			margin-top: 0.5em;
		}

		&__control {
			display: none;

			&--close {
				display: block;
				margin: 0;
				margin-top: -38px;
				opacity: 0;
			}
		}

		&__item {
			border: none;
			border-radius: 0;
			border-top: thin solid #ebeff2;
		}

		@media screen and (prefers-reduced-motion: no-preference) {
			transition-property: scrollbar-color, right;

			&__control--close {
				transition: 300ms ease-in-out;
				transition-property: opacity, margin;
			}
		}

		@media screen and (max-width: 1350px) {
			right: -275px;

			&--open {
				right: 0;
			}

			&__control {
				display: block;

				&--open {
					display: block;
					position: fixed;
					right: 0;
					background: #f8f9fa;
					width: max-content;
					// top: 2.5em;
					top: 3em;

					transition: 300ms ease-in-out;
					transition-property: transform, opacity;
				}

				&--close {
					margin: 0;
					opacity: 1;
				}

				&--open#{&}--hidden {
					opacity: 0;
					transform: translateX(100%);
				}
			}
		}
	}

	.l-main {
		overflow-x: hidden;

		&__container {
			display: grid;
			grid-template-columns: 1fr auto;
			padding: 0;
			margin: 0;
		}

		@media screen and (max-width: calc(210mm + 245px)) {
			&__container {
				grid-template-columns: 100% auto;
				transition: transform 300ms ease-in-out;

				&.floating-menu--isOpen {
					transform: translateX(-275px);
				}
			}
		}

		&__left-panel {
			transition: transform 300ms ease-in-out;
		}
	}

	.btn-sinao-annulation {
		padding: 17px;
		margin-top: 5px;
	}

	.tagBeta {
		position: absolute;
		z-index: 1;
		top: 4.575px;
		right: 13.5px;
		padding: 4px;
		background-color: rgba(187, 197, 210, 0.5);
		border-radius: 2px;
		color: #2A3E53;
		font-size: 12px;
		font-weight: 500;
	}

	.b-overlay-wrap.position-relative > .b-overlay.position-absolute {
		margin-left: 0px !important;
		margin-right: 0px !important;
	}
</style>

<!--
dev notes on this component, remove before puting in prod

version mobile:
	fermé par defaut, position et forme du bouton pour ouvrir?
		bouton fixé au bord de l'ecran a droite avec un ⚙
	overlap sur tout l'ecran?
		decalage de l'ecran vers la gauche

version bureau:
	fermé si l'ecran n'est pas assez large
		décale le viewport? overlap?
	position et forme du bouton

section lang et devise
	qu'est-ce qui doit etre impacté par la langue
	liste des devises prises en charges


interface de suppression des pieces jointes => je la met ou la croix ?

-->
